import React, { useState, useEffect } from "react";
import Footer from "./footer";
import { db } from "../firebase"; // adjust path if needed
import { collection, getDocs, query, where, orderBy, limit } from "firebase/firestore";

const AllCourses = () => {
  const [search, setSearch] = useState("");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCourses = async () => {
    try {
      const snapshot = await getDocs(collection(db, "courses"));
      const courseList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
  
      // ✅ Sort so that featured courses appear first
      const sortedCourses = courseList.sort((a, b) => {
        // 1️⃣ Featured courses first
        if (a.featured && !b.featured) return -1;
        if (!a.featured && b.featured) return 1;
  
        // 2️⃣ Within same group, latest createdAt first
        const aTime = a.createdAt?.seconds || 0;
        const bTime = b.createdAt?.seconds || 0;
        return bTime - aTime;
      });
  
      setCourses(sortedCourses);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const filteredCourses = courses.filter((course) =>
    course.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="bg-gradient-to-b from-[#FFF3EB] to-white min-h-screen font-sans px-6 md:px-16 py-10 pt-24">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-8">
          <h1 className="text-2xl font-bricolage md:text-3xl font-bold text-gray-900 mb-4 md:mb-0">
            Explore all courses
          </h1>

          {/* Search Bar */}
          <div className="relative w-full md:w-72">
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border border-gray-300 rounded-full py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-gray-500 absolute left-3 top-2.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"
              />
            </svg>
          </div>
        </div>

        {/* Courses Grid */}
        {loading ? (
          <p className="text-center text-gray-600">Loading courses...</p>
        ) : filteredCourses.length === 0 ? (
          <p className="text-center text-gray-600">No courses found.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCourses.map((course) => (
              <div
  key={course.id}
  className="relative bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition overflow-hidden"
>
  {/* ⭐ Featured badge */}
  {course.featured && (
                  <div className="absolute top-3 right-3 bg-black text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md flex items-center gap-1">
      <span>⭐</span> Featured
    </div>
  )}

  {course.imageUrl && (
    <img
      src={course.imageUrl}
      alt={course.title}
      className="w-full h-auto object-cover"
    />
  )}

  <div className="p-4">
    <h2 className="text-base font-semibold text-gray-800 mb-2">
      {course.title}
    </h2>
    <p className="text-gray-600 text-sm mb-3">{course.description}</p>
    <p className="text-lg font-semibold text-gray-900 mb-4">
      ₹ {course.price}
    </p>

    {/* ✅ Show View / Enroll button */}
    {course.courseLink ? (
      <a
        href={(() => {
          let link = course.courseLink.trim();
          link = link.replace(/^http\/\/:/i, "http://").replace(/^https\/\/:/i, "https://");
          if (!/^https?:\/\//i.test(link)) {
            link = `https://${link}`;
          }
          return link;
        })()}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#F15A29] text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-[#e14f1f] transition inline-block"
      >
        View Course
      </a>
    ) : (
      <button className="bg-[#F15A29] text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-[#e14f1f] transition">
        Enroll now
      </button>
    )}
  </div>
</div>

            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AllCourses;
